export class NearByPromo{


  constructor(public idComercio: number, public nombre: string, public idSucursal: number, public sucursal: string, public latitud: number, public longitud: number,
              public direccion: string, public colonia: string, public municipio: string, public ciudad: string, public estado: string, public codigoPostal: string) {
  }

}
